require('./brokerMyInvestmentsProductsEmptyStates.scss');

const PropTypes = require('prop-types');
// @ vendor
const React = require('react');
// @ commons
const { OKLink } = require('commonsComponents/OKLink');
const { EmptyState } = require('commonsComponents/emptyState');
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');

// @components
const { BrokerMyInvestmentsWrappedProductsTable } = require('../brokerMyInvestmentsWrappedProductsTable/brokerMyInvestmentsWrappedProductsTable');

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;

// @constants
const {
  EURO_TEXT,
  BROKER_CUSTOM_WALLET_CONFIGURATION_URL,
  MYPROFILE_BROKER_EXPLORE_URL,
  TYPE_ALTERNATIVE_FUNDS_PG,
} = require('constants/index');
const { taggingEventHandled } = require('utilities/taggingEventHandled');

class BrokerMyInvestmentsProductsEmptyStates extends React.Component {

    handleBuyLinkClick = () => {
        const { productType, resetSpecificProduct } = this.props;
        const product = productType === TYPE_ALTERNATIVE_FUNDS_PG ? 'alternative_funds' : productType;
        taggingEventHandled(this.props.pageName, 'emptyStateLink', 'link', product)
        resetSpecificProduct(product.toUpperCase());
    }

    render() {
        const { immMyWalletCharts, productType } = this.props;
        const product = productType === TYPE_ALTERNATIVE_FUNDS_PG ? 'alternative_funds' : productType;
        const title = formatText(`broker-investments${productType}TableTitle`);
        const pluralProductName = formatText(`broker-` + product);
        const typeString = formatText(`broker-investments${productType}TableEmptyTextType`);
        const defaultCurrency = EURO_TEXT; // @hardcoded

        let emptyState;
        const isGeneralViewSelected = immMyWalletCharts ? immMyWalletCharts.get('isGeneralViewSelected') : true;
        if (isGeneralViewSelected) {
            const buyLink = (
                <OKLink modifier="emphasize" onClick={this.handleBuyLinkClick} to={`${MYPROFILE_BROKER_EXPLORE_URL}/${product}`} >
                    <FormattedText
                        value="broker-myInvestementsGoTo"
                        injectedStrings={[pluralProductName]}
                    />
                </OKLink>
            );
            emptyState = (
                <EmptyState
                    primaryText={formatText(`broker-myInvestmentsProductsEmptyGeneralView`, [typeString])}
                    button={buyLink}
                    iconType="noitems-wealth"
                />
            );
        } else {
            const customWalletConfiguration = (
                <OKLink
                    modifier="emphasize"
                    extraClass="broker-tables__configuration-link"
                    to={BROKER_CUSTOM_WALLET_CONFIGURATION_URL}>
                    <FormattedText value="broker-customWalletConfiguration" />
                </OKLink>
            );
            const buyLink = (
                <OKLink
                    modifier="emphasize"
                    extraClass="broker-my-investments-tables__configuration-link"
                    onClick={this.handleBuyLinkClick}
                    to={`${MYPROFILE_BROKER_EXPLORE_URL}/${productType}`} >
                    <FormattedText
                        value="broker-myInvestmentsBuyProducts"
                    />
                </OKLink>
            );
            const primaryTextWithComponents = (
                <div className="broker-my-investments-products-empty-state__text">
                    <div>
                        {formatText('broker-myInvestmentsProductsEmpty')}
                    </div>
                    <FormattedTextWithComponents
                        value="broker-myInvestmentsProductsEmptyCustomView"
                        injectedComponents={[buyLink, pluralProductName, customWalletConfiguration]}
                    />
                </div>
            );
            emptyState = (
                <EmptyState
                    secondaryText={primaryTextWithComponents}
                    iconType="noitems-wealth"
                />
            );
        }

        return (
            <BrokerMyInvestmentsWrappedProductsTable
                type={productType}
                productType={title}
                itemsNumber={0}
                earnings={0}
                earningsPercentage={0}
                currency={defaultCurrency}
                total={0}
                capital={0}
                hasExcludedItems={false}
                onOpenTraderClick={this.props.onOpenTraderClick}
                setOrdersAndMovementsAccessFrom={this.props.setOrdersAndMovementsAccessFrom}
                pageName={this.props.pageName}
            >
                {emptyState}
            </BrokerMyInvestmentsWrappedProductsTable>
        );
    }
}

BrokerMyInvestmentsProductsEmptyStates.propTypes = {
    immMyWalletCharts: PropTypes.object,
    productType: PropTypes.string,
    onOpenTraderClick: PropTypes.func.isRequired,
    setOrdersAndMovementsAccessFrom: PropTypes.func.isRequired,
    resetSpecificProduct: PropTypes.func.isRequired,
    pageName: PropTypes.string
};

module.exports = BrokerMyInvestmentsProductsEmptyStates;
